export const environment = {
  emailPattern: '^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}$',
  phonePattern: '^[+]?[0-9]{0,20}$',
  numbersPattern: '^[0-9]+(\.[0-9]+)*$',

  production: false,
  host: 'https://apidev.liftenergyplus.co.uk/'
};
